<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick">
          <el-tab-pane label="业主续签" name="renewalOwnerRentRecord">
            <renewal-owner-rent-record ref="renewalOwnerRentRecord"></renewal-owner-rent-record>
          </el-tab-pane>
          <el-tab-pane label="租客续签" name="renewalRentRecord">
            <renewal-rent-record ref="renewalRentRecord"></renewal-rent-record>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import RenewalOwnerRentRecord from "@/components/RenewalOwnerRentRecord";
import RenewalRentRecord from "@/components/RenewalRentRecord";

export default {
  components: {
    RenewalOwnerRentRecord,
    RenewalRentRecord
  },
  data() {
    return {
      active: 'renewalOwnerRentRecord'
    }
  },
  methods: {
    tabClick() {
      const tab = this.active
      if (tab == 'renewalOwnerRentRecord') {
        this.$refs['renewalOwnerRentRecord'].search(true)
      } else if (tab == 'renewalRentRecord') {
        this.$refs['renewalRentRecord'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/renewal.vue